import { render, staticRenderFns } from "./AppForm.vue?vue&type=template&id=4d95fdf8&scoped=true&"
import script from "./AppForm.vue?vue&type=script&lang=js&"
export * from "./AppForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d95fdf8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d95fdf8')) {
      api.createRecord('4d95fdf8', component.options)
    } else {
      api.reload('4d95fdf8', component.options)
    }
    module.hot.accept("./AppForm.vue?vue&type=template&id=4d95fdf8&scoped=true&", function () {
      api.rerender('4d95fdf8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/event/modules/AppForm.vue"
export default component.exports